<template>
	<span class="tag is-dark is-rounded is-font-small" style="width: fit-content" v-bind:class="{ isRight: isRight }"
		v-bind:style="{
			'background-color': tagColor,
			color: getColor(tagColor),
		}">
		{{ tagName }}
	</span>
</template>

<script>
/**
 * Tag displaying the associated EntryType with a tagColor and tagColor.
 * @displayName EntryTypeTag
 */

import { textColorForBackground } from "@/lib/Color";

export default {
	name: "EntryTypeTag",
	props: ["tagName", "tagColor", "isRight"],
	methods: {
		getColor(hex) {
			if (hex) {
				return textColorForBackground(hex);
			}

		},
	},
};
</script>

<style scoped>
.isRight {
	float: right;
}
</style>
